import i18next from "i18next";
import React, { useEffect, useState } from "react";
import Utils from "common/utils";
import ProgressBar from "../progressBar";
import PlanIcon from "../../resources/icons/plan.svg";

import "./cards.scss";
import AnimatedCounter from "components/animatedCounter";
import { useDispatch } from "react-redux";
import { setAppModal } from "redux/slices/appSlice";
import { MODALS } from "common";

export default function CompanyPlanCard({
  allUsers,
  activeUsers,
  expirationDate,
  tenantName,
  isTenant = false,
  className = "",
}) {
  const dispatch = useDispatch();
  const expirationDateString = new Date(expirationDate);
  const formattedExpiry = Number.isNaN(expirationDateString.getTime())
    ? i18next.t("labels.not_available")
    : `${expirationDateString.getUTCDate()}/${expirationDateString.getUTCMonth() + 1}/${expirationDateString.getUTCFullYear()}`;
  const totalSeats =
    allUsers === null || allUsers === undefined || allUsers === ""
      ? null
      : Number.isFinite(Number(allUsers))
      ? Number(allUsers)
      : null;
  const activeSeatCount = Number(activeUsers) || 0;
  const openSeatUsage = () => {
    if (isTenant) {
      dispatch(
        setAppModal({
          modal: MODALS.SEAT_USAGE,
          data: {
            tenantName,
            activeSeats: activeSeatCount,
            totalSeats,
          },
        })
      );
    }
  };
  return (
    <div
      className={`card white noGap profile ${className} plan ${isTenant ? "tenant-seat-card" : ""}`}
      onClick={openSeatUsage}
      onKeyDown={(event) => {
        if (isTenant && (event.key === "Enter" || event.key === " ")) {
          event.preventDefault();
          openSeatUsage();
        }
      }}
      role={isTenant ? "button" : undefined}
      tabIndex={isTenant ? 0 : undefined}
      aria-label={isTenant ? i18next.t("labels.open_seat_usage") : undefined}
    >
      <div className="row">
        <img className="icon" src={PlanIcon} alt="plan" />
        <div className="colum">
          <div className="planDetails">
            {isTenant
              ? i18next.t("labels.seat_usage")
              : `${Utils.numberWithCommas(allUsers)} plan`}
          </div>
          {/* // TODO: expiration date must be reformatted depend on how we will get it from BE 
                  for demo we will use it staticly here for now */}

          <div className="expire">
            {isTenant
              ? i18next.t("labels.view_seat_details")
              : `${i18next.t("labels.expires")}: ${formattedExpiry}`}
          </div>
        </div>
      </div>
      <div className="colum">
        <div className="numbers count">
          <AnimatedCounter finish={activeSeatCount} useComma />
          &nbsp;
          {`${i18next.t("labels.of")} ${
            totalSeats === null
              ? i18next.t("labels.not_set")
              : Utils.numberWithCommas(totalSeats)
          } ${i18next.t(isTenant ? "labels.seats" : "labels.users_small")}`}
        </div>
        <div className="progress">
          <ProgressBar
            width={"100%"}
            height={8}
            progress={totalSeats > 0 ? activeSeatCount / totalSeats : 0}
            progressColor={"#5ac2b4"}
            backgroundColor={"#d4efeb"}
          />
        </div>
      </div>
    </div>
  );
}
